import type { FC } from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Banner persistente pro admin que segue operando durante a manutenção
 * (28/09/2026, contrato Front — docs/superpowers/plans/2026-09-28-
 * manutencao-no-login.md): quando `pode_operar === true` E a manutenção
 * trava o resto do sistema, o ProtectedRoute (App.tsx) monta este banner em
 * vez de redirecionar pra /maintenance — lembra o admin, o tempo todo, que
 * ele está numa exceção.
 *
 * `role="status"` (não "alert"): é informativo e permanece na tela; um
 * alerta interromperia o leitor de tela a cada navegação enquanto durar a
 * manutenção.
 */
export const AdminMaintenanceBanner: FC = () => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 bg-amber-500 text-amber-950 dark:bg-amber-600 dark:text-amber-50 px-4 py-2 text-sm font-medium"
    >
      <ShieldCheck className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>Manutenção ativa — você está operando como administrador</span>
    </div>
  );
};
